import { useBFFWebChatState } from './useBFFWebChatState';
export function useBFFWebChatDispatch() {
    const [, dispatch] = useBFFWebChatState();
    return dispatch;
}
//# sourceMappingURL=useBFFWebChatDispatch.js.map